import React from 'react';
import {Button} from '../Button/Button';
import type {ButtonProps} from '../Button/Button';
import {usePopoverContext} from './PopoverContext';
import useMergedRefs from '@restart/hooks/useMergedRefs';
import {composeEventHandlers} from '../utils/composeEventHandlers';

export interface PopoverButtonProps extends ButtonProps {
    /** @default Button */
    component?: React.ElementType<any>;
}

export const PopoverButton = React.forwardRef<any, PopoverButtonProps>(
    (
        {
            children,
            component: Component = Button,
            onClick,
            ...props
        },
        ref
    ) => {
        const {
            open,
            handleToggle,
            anchorRef,
            popoverId
        } = usePopoverContext('Button');

        const mergedRef = useMergedRefs(anchorRef, ref);
        const onClickEvents = composeEventHandlers(handleToggle, onClick);

        return (
            <Component
                aria-controls={open ? popoverId : undefined}
                aria-expanded={open}
                aria-haspopup='dialog'
                onClick={onClickEvents}
                ref={mergedRef}
                {...props}
            >
                {children}
            </Component>
        );
    });

PopoverButton.displayName = 'PopoverButton';
